import React from 'react';
import { DataTableColumn } from '../_custom/DataTable/DataTable.types';
import { isEmpty } from '../../utils/utils';

const extractText = (node: React.ReactNode): string => {
    if (isEmpty(node) || typeof node === 'boolean') return '';
    if (typeof node === 'string' || typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map(extractText).join('');
    if (React.isValidElement(node)) return extractText((node.props as { children?: React.ReactNode }).children);
    return '';
};

// Plain-text label: the original label, else the text found in a string/JSX header ('' when there is none).
const getPropertyLabel = (column: DataTableColumn): string => column.headerOriginalLabel || extractText(column.headerLabel).trim();

// Case-insensitive substring match on the property label; a blank query keeps every column,
// and so does a column with no readable label (it can't be matched, so hiding it would be silent).
export function filterColumnsByLabel(columns: DataTableColumn[], query: string): DataTableColumn[] {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return columns;
    return columns.filter((column) => {
        const label = getPropertyLabel(column);
        return !label || label.toLowerCase().includes(normalizedQuery);
    });
}
